<template>
  <b-col order-sm="2" order="1" align-self="center" class="white-box selects">
    <div class="d-flex w-100">
      <img src='@/assets/origin_icon.svg' alt='origin_icon'>
      <slot name="options"></slot>
    </div>
  </b-col>
</template>

<script>
export default {

}
</script>

<style>

</style>
